// libs
import React from 'react'
import { useHistory, useRouteMatch } from 'react-router-dom'

// interfaces / constants
import { IAddress } from 'src/interfaces/address'
import {
  ILandingPageTracker,
  IPage404Tracker,
  LocationPickerPageTracker,
  MapControlsTracker
} from 'src/utils/reporting/events_tracking/events_tracking'

// classes / components
import LocationPicker from 'src/components/location_picker/location_picker'

// helpers
import { useGetAppLocationShape } from 'src/reducers/app-state/app-state_hooks'
import { replaceLocationSlugFromPath } from 'src/utils/url/url'

interface IProps {
  tracking: MapControlsTracker | IPage404Tracker | ILandingPageTracker | LocationPickerPageTracker;
  showBackground?: boolean;
  onPick?: () => void;
  onClose?: () => void;
}

const AppLocationPicker: React.FC<IProps> = ({
  tracking: { trackingObj, tracker },
  showBackground = true,
  onPick,
  onClose
}) => {
  const locationShape = useGetAppLocationShape()
  const match = useRouteMatch()
  const history = useHistory()

  const getRedirectPath = (locationSlug: string) => replaceLocationSlugFromPath(match, locationSlug)

  const handleAddress = (address: IAddress) => {
    onPick?.()
    tracker(trackingObj.ACTIONS.CHANGE_LOCATION, trackingObj.LABELS.START)

    history.push(getRedirectPath(address.locationShape.slug))
  }

  const onPopularPlacesSelect = () => {
    onPick?.()
    tracker(trackingObj.ACTIONS.SELECT_POPULAR_PLACE, trackingObj.LABELS.START)
  }

  const trackLocateMe = () => {
    onPick?.()
    tracker(trackingObj.ACTIONS.LOCATE_ME, trackingObj.LABELS.START)
  }

  return (
    <LocationPicker
      area={locationShape?.slug}
      onChange={handleAddress}
      showBackground={showBackground}
      autoFocusSearchInput={false}
      onLocateMe={trackLocateMe}
      getRedirectPath={getRedirectPath}
      onPopularPlacesSelect={onPopularPlacesSelect}
      close={onClose}
    />
  )
}

export default AppLocationPicker
